import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InvoiceDataChangeDTO } from '@mwe/models';
import { getProductCategoryLabelKey, isProductCategoryFernwaerme } from '@mwe/utils';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';

export interface SepaMandatProductsListItem {
  categories: string[];
  payee: string;
  creditorId: string;
  customerNumber: string;
  accountNumber: string;
  mandateReference?: string;
  isFernwaerme: boolean;
  fernwaermePayee: string;
  fernwaermeCreditorId: string;
}

@Component({
  selector: 'mwe-sepa-mandat-listing',
  templateUrl: './sepa-mandat-listing.component.html',
  imports: [NgClass, TranslateDirective, BasicCardComponent, NgTemplateOutlet, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SepaMandatListingComponent {
  changeData = input.required<InvoiceDataChangeDTO>();
  asCard = input<boolean>(false);

  items = computed(() => {
    return this.changeData().mappingData.map(d => {
      return {
        categories: d.categories.map(c => getProductCategoryLabelKey(c)),
        payee: 'sepaInvoiceChange.status.sepaInfo.company.name',
        creditorId: 'sepaInvoiceChange.status.sepaInfo.company.creditorId',
        customerNumber: d.customerNumber,
        accountNumber: d.accountNumber,
        mandateReference: this.getMandateRefernce(d.accountNumber),
        isFernwaerme: !!d.categories.find(c => isProductCategoryFernwaerme(c)),
        fernwaermePayee: 'sepaInvoiceChange.status.sepaInfo.fernwaermeCompany.name',
        fernwaermeCreditorId: 'sepaInvoiceChange.status.sepaInfo.fernwaermeCompany.creditorId',
      } as SepaMandatProductsListItem;
    });
  });

  getPartsToShow(isFernwaerme: boolean) {
    return isFernwaerme
      ? ['fernwaermePayee', 'fernwaermeCreditorId', 'customerNumber', 'mandateReference']
      : ['payee', 'creditorId', 'customerNumber', 'accountNumber', 'mandateReference'];
  }

  private getMandateRefernce(accountNumber: string): string {
    const item = this.changeData().mandatsReferenzMapping.find(i => {
      return i.vertragskontoNummer === accountNumber;
    });

    return item?.mandatsreferenz;
  }
}
